"use strict";

var _classCallCheck = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var i18n_1 = __importDefault(require("../../i18n"));

var facets_1 = require("../facets");

var TipoTrabajoFilter = /*#__PURE__*/function () {
  function TipoTrabajoFilter() {
    _classCallCheck(this, TipoTrabajoFilter);
  }

  _createClass(TipoTrabajoFilter, null, [{
    key: "makeFilter",
    value: function makeFilter(keyword) {
      if (keyword) {
        var tipoTrabajo = i18n_1.default.t("url.tipo-trabajo.".concat(keyword), {
          defaultValue: keyword
        });
        return "-".concat(tipoTrabajo);
      }

      return '';
    }
  }, {
    key: "parseFilter",
    value: function parseFilter(urlToParse) {
      var tiposDeTrabajo = Object.keys(facets_1.filterMap.tipo_trabajo);
      var tipoTrabajo = tiposDeTrabajo.find(function (tipo) {
        var tipoTrabajoTrad = i18n_1.default.t("url.tipo-trabajo.".concat(tipo), {
          defaultValue: tipo
        });
        return urlToParse.includes("".concat(tipoTrabajoTrad));
      });
      var tipoTrabajoToRemove = i18n_1.default.t("url.tipo-trabajo.".concat(tipoTrabajo), {
        defaultValue: tipoTrabajo
      });
      return {
        url: urlToParse.split("-".concat(tipoTrabajoToRemove)).join(''),
        result: tipoTrabajo
      };
    }
  }]);

  return TipoTrabajoFilter;
}();

exports.TipoTrabajoFilter = TipoTrabajoFilter;